import {
  parseOptionsSchema,
  Budget,
  TabularError,
  type ParseOptions,
  type Runtime,
  type TabularResult,
} from "./types";
import { parseText } from "./text";
import { parseWorkbook } from "./xlsx";
export * from "./types";
export async function parseTabular(
  bytes: Uint8Array,
  raw: ParseOptions = {},
  runtime: Runtime = {},
): Promise<TabularResult> {
  const options = parseOptionsSchema.parse(raw),
    budget = new Budget(options, runtime);
  budget.check();
  if (!bytes.length || bytes.length > budget.limits.inputBytes)
    throw new TabularError(
      "INPUT_LIMIT",
      "Input byte size is outside its limits",
    );
  if (
    bytes[0] === 0xd0 &&
    bytes[1] === 0xcf &&
    bytes[2] === 0x11 &&
    bytes[3] === 0xe0
  )
    throw new TabularError(
      "LEGACY_WORKBOOK",
      "Encrypted or legacy binary workbooks are unsupported",
    );
  const zip =
    bytes[0] === 80 && bytes[1] === 75 && bytes[2] === 3 && bytes[3] === 4;
  if (options.format === "xlsx" || (options.format === "auto" && zip))
    return parseWorkbook(bytes, budget);
  return parseText(bytes, budget);
}
